import { Dispatch, SetStateAction } from "react";
import { IRegistrationSheetInfo, IUrlInfo } from "./commonModels";
import { IRegistrationSheetData } from "./registrationModels";
import { ApiResponse } from "../repos/registrationRepos";

export interface ITenantState extends IRegistrationSheetInfo {
    urlInfo?: IUrlInfo;
    registrationSheetData: IRegistrationSheetData;
  }
  export   interface IErrorResponse {
    message: string;
  }
  export  const initialState: ITenantState = {
    // From IUrlInfo
    urlInfo: undefined,
    // From RegistrationSheetInfo
    registrationSheetId: 0,
    database: "",
  
    // from IRegistrationSheetData
    registrationSheetData: {
      company: {
        name: "",
        zip: "",
        city: "",
        street: "",
        guestCardActive: false
      },
      registrationSheet: {
        id: 0,
        number: "",
        arrival: "",
        departure: "",
        personsTaxBound: 0,
        personsFree: 0,
        personsTotal: 0,
        isTravelGroup: false,
        visitor: {
          id: "",
          salutation: "",
          prename: "",
          name: "",
          gender: "",
          birthDate: "",
          birthState: "",
          state: "",
          zip: "",
          city: ""
        },
        companions: [],
        originCountries: [],
        advertisingAgreement: {
          text: "",
          consented: false
        },
        guestCardAgreement: {
          text: "",
          consented: false
        },
        additionalInformation: ""
      }
    }
  };
  export interface IActiveState {
    registrationSheetHasArrived: boolean;
    embeddedHasArrived: boolean;
    qrCodeHasArrived: boolean;
    emptyResponse: boolean;
  };
  
  export  interface ISetEmbeddedInfoAction {
    type: 'SET_EMBEDDED_INFO';
    url: string;
  }
  
  export  interface ISetQrCodeInfoAction {
    type: 'SET_QRCODE_INFO';
    url: string;
    title: string;
    label: string;
    text: string;
  }
  
  export interface ISetRegistrationInfoAction extends IRegistrationSheetInfo {
    type: 'SET_RES_INFO';
  }
  
  
  export type TenantActions =
    | ISetEmbeddedInfoAction
    | ISetQrCodeInfoAction
    | ISetRegistrationInfoAction
    | { type: 'UPDATE_GUESTCARD_CONSENT'; payload: boolean }
    | { type: 'UPDATE_ADVERT_CONSENT'; payload: boolean }
    | { type: 'LOAD_RS_DATA'; registrationSheet: IRegistrationSheetData }
    | { type: 'CLEAR' };
  
  
 export interface ITenantContext {
    tenant: ITenantState;
    dispatchTenant: Dispatch<TenantActions>;
    isRequestPending: boolean;
    isConnectionError: boolean,
    connectionErrorMessage: string,
    activeState: IActiveState;
    updateActiveState: (key: keyof IActiveState) => void;
    setIsRequestPending: Dispatch<SetStateAction<boolean>>;
    sendRegistrationSheet: (value: string) => Promise<ApiResponse>;
  }
  